<template>
  <div>
    <my-search
      timeScreen
      :order="1"
      :searchParams="searchParams"
      @searchEvent="searchEvent"
    />
    <!-- 表格展示查询的数据  -->
    <myTable
      :loading="loading"
      :tableData="tableData"
      :tableHeader="tableHeader"
    />
    <!-- 分页器 -->
    <my-pagination :childMsg="pageParams" @callFather="callFather" />
  </div>
</template>
<script>
import {
  reqRecordList,
  reqGetUser,
  reqGetUserList,
} from "@/network/workManage/depositRec";
import { canSearch } from "../../utils/utils";
import mixins from "@/mixins/common";
export default {
  name: "consumingRec",
  mixins: [mixins],
  data() {
    return {
      searchParams: { timeOptions: [] },
      UserList: [],
      tableHeader: Object.freeze([
        {
          name: "充值用户",
          prop: "userName",
        },
        {
          name: "价格",
          prop: "price",
        },
        {
          name: "购买数量",
          prop: "num",
        },
        {
          name: "支付类型",
          prop: "payType",
        },
        {
          name: "支付状态",
          prop: "status",
        },
        {
          name: "积分",
          prop: "integral",
        },
        {
          name: "创建时间",
          prop: "createTime",
        },
      ]),
    };
  },
  methods: {
    async getInitData(isSearch) {
      let { timeOptions } = this.searchParams;
      let params = {
        current: isSearch ? 1 : this.pageParams.currentPage,
        size: this.pageParams.pageSize,
        startTime: timeOptions ? timeOptions[0] : undefined,
        endTime: timeOptions ? timeOptions[1] : undefined,
      };
      let { data } = await reqRecordList(params);
      // console.log(data);
      if (data.code == 200) {
        this.loading = false;

        // data.data.records.map(async (item) => {
        //   reqGetUser(item.userId).then((data) => {
        //     item.user = data.data.data.userZh;
        //   });
        // });

        // 给table添加对应的用户姓名
        data.data.records.map((item) => {
          let index = this.UserList.findIndex((item1) => {
            return item.userId == item1.id;
          });
          if (index >= 0) {
            item.user = this.UserList[index].userZh;
          }
        });
        
        this.loading = false;
        this.tableData = data.data.records;
        this.pageParams.total = data.data.total;
        if (isSearch) this.pageParams.currentPage = 1;
      }
    },
    searchEvent() {
      //相同参数避免二次搜索
      if (canSearch(this, this.searchParams)) return;
      console.log("搜索了");
      this.getInitData(true);
    },
    async getUserList() {
      let { data } = await reqGetUserList();
      if (data.code == 200) {
        this.UserList = data.data;
      }
    },
  },
  created() {
    this.getUserList();
  },
};
</script>
<style>
</style>